<template>
  <div class="login-footer">
    Copyright &copy; {{ (new Date).getFullYear() }} 澄合矿业有限公司物资供销分公司&nbsp;&nbsp;|&nbsp;&nbsp;联系地址：陕西省渭南市澄城县城关镇南新街65号&nbsp;&nbsp;|&nbsp;&nbsp;邮政编码：715200&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://beian.mps.gov.cn/" target="_blank">陕ICP备2025059416号-1</a>
  </div>
</template>

<script>
export default {
  name: 'LoginFooter'
}
</script>

<style lang="less" scoped>
.login-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 24px;
    color: #B1B9C3;
    text-align: center;
    background-color: #42464B;
    
    a {
        color: #B1B9C3;
    }
}
</style>